import { ToCorrectFileDataLengthBaseValueConverter } from 'General/Resources/ValueConverters/ToCorrectFileDataLengthBase';
export class ToCorrectFileDataLengthValueConverter extends ToCorrectFileDataLengthBaseValueConverter {

}